import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireNamespaceEmitter } from "../node_modules/.pnpm/namespace-emitter@2.0.1/node_modules/namespace-emitter/index.js";
var namespaceEmitterExports = requireNamespaceEmitter();
const ee = /* @__PURE__ */ getDefaultExportFromCjs(namespaceEmitterExports);
export {
  ee as default
};
//# sourceMappingURL=index.js.map
